export enum $project {
  _id = '_id',
  name = 'name',
  key = 'key',
  ownerId = 'ownerId',
  startDate = 'startDate',
  workspaceId = 'workspaceId',
  endDate = 'endDate',
  description = 'description',
  issueIntegrationConnectionId = 'issueIntegrationConnectionId',
  issueIntegrationStatusMappingId = 'issueIntegrationStatusMappingId',
  issueIntegrationConfiguredFieldsId = 'issueIntegrationConfiguredFieldsId',
  issueIntegrationConfiguredFields = 'issueIntegrationConfiguredFields',
  issueIntegrationProjectName = 'issueIntegrationProjectName',
  issueIntegrationProjectKey = 'issueIntegrationProjectKey',
  issueIntegrationProjectId = 'issueIntegrationProjectId',
  issueIntegrationProjectInstance = 'issueIntegrationProjectInstance',
  issueIntegrationProject = 'issueIntegrationProject',
  status = 'status',
  issueIntegrationConnection = 'issueIntegrationConnection',
  tenantId = 'tenantId',
  customLabels = 'customLabels',
  automaticValidation = 'automaticValidation',
}

export enum $projectAutomaticValidation {
  enabled = 'enabled',
  batchSize = 'batchSize',
  testingEnvironment = 'testingEnvironment',
  additionalDetails = 'additionalDetails',
  attachmentIds = 'attachmentIds',
  attachments = 'attachments',
}

export enum $automaticValidationAttachment {
  id = 'id',
  name = 'name',
  size = 'size',
  createdAt = 'createdAt',
}

export enum $automaticValidationPendingCount {
  pendingTaskCount = 'pendingTaskCount',
}

export const AUTOMATIC_VALIDATION_MAX_BATCH_SIZE: number = 99;

export enum $projectCustomLabel {
  _id = '_id',
  name = 'name',
  hasLinkedTasks = 'hasLinkedTasks',
}

export const CUSTOM_LABEL_MAX_COUNT: number = 10;
export const CUSTOM_LABEL_NAME_MAX_LENGTH: number = 100;

export enum $createProjectPagePath {
  pagePath = 'pagePath',
}

export enum ProjectStatus {
  active = 'active',
  archived = 'archived',
}

export enum ProjectAction {
  archive = 'archive',
  delete = 'delete',
  delete_with_linked_task = 'delete_with_linked_task',
  restore = 'restore',
}

export enum $projectWithOwner {
  owner = 'owner',
}

export enum $projectWithStatusMapping {
  issueIntegrationStatusMapping = 'issueIntegrationStatusMapping',
}

export const PUBLIC_PROJECTS_LIMIT_DEFAULT: number = 10;
export const PUBLIC_PROJECTS_LIMIT_MAX: number = 100;

export const PUBLIC_API_CREATE_PROJECT_PAGE_PATH: string = 'Public API';

export const CHAR_LIMITS: Readonly<Partial<Record<$project | 'keyMin', number>>> = Object.freeze({
  [$project.name]: 100,
  [$project.description]: 255,
  [$project.key]: 5,
  keyMin: 2,
});

export const ProjectIssueTrackingProperties: ($project | $projectWithStatusMapping)[] = [
  $project.issueIntegrationConnectionId,
  $project.issueIntegrationConnection,
  $project.issueIntegrationProject,
  $project.issueIntegrationConfiguredFieldsId,
  $project.issueIntegrationConfiguredFields,
  $project.issueIntegrationStatusMappingId,
  $projectWithStatusMapping.issueIntegrationStatusMapping,
];
